import { render, staticRenderFns } from "./ModuleUserSettingsManager.vue?vue&type=template&id=686c09be&scoped=true&"
import script from "./ModuleUserSettingsManager.vue?vue&type=script&lang=ts&"
export * from "./ModuleUserSettingsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c09be",
  null
  
)

export default component.exports